var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoTransferOutlinedWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bus",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25.5,
    height: 24.61,
    viewBox: "0 0 25.5 24.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_318",
    "data-name": "Rectangle 318",
    width: 19.79,
    height: 20.61,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "message",
    transform: "translate(1.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 24,
    height: 24,
    fill: "#fff",
    opacity: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1881",
    "data-name": "Groupe 1881",
    transform: "translate(0 4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1880",
    "data-name": "Groupe 1880",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_598",
    "data-name": "Trac\\xE9 598",
    d: "M7.11,11a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,7.11,11m11.28,9.61-1.64-1.64a.7.7,0,0,1-.14.03h-1a1,1,0,0,1-1-1V17h-8v1a1,1,0,0,1-1,1h-1a1,1,0,0,1-1-1V16.22a2.986,2.986,0,0,1-1-2.22V4.83L0,2.22,1.41.81,19.79,19.19l-1.4,1.42M4.61,6.83V8H5.78ZM12.78,15l-5-5H4.61v4a.968.968,0,0,0,.34.73l.29.27ZM10.61,2c3.69,0,5.11.46,5.66.99H6.43l2,2h8.18V8H11.44l2,2h3.17v3.17l1.81,1.81a2.894,2.894,0,0,0,.19-.98V4c0-3.5-3.58-4-8-4C8.09,0,5.85.16,4.39.95L5.92,2.48A16.136,16.136,0,0,1,10.61,2",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTransferOutlinedWhite);
export default __webpack_public_path__ + "static/media/NoTransferOutlinedWhite.6c292019d3e0343fbf9235690f9b40b6.svg";
export { ForwardRef as ReactComponent };